// extracted by mini-css-extract-plugin
export default {"content":"GeneratedResponseCard_content__MR600","card":"GeneratedResponseCard_card__p6HNw"};